/* eslint-disable */
import LogRocket from "logrocket";

export const isDev = () => {
  let domains = ['localhost', '172.19.45.14']
  
  return domains.some((d) => window.location.hostname == d)
}

export const log = ({ msg, obj = null, arr = null }) => {
  if (!msg) {
    console.warn('There is no msg property passed, please add msg property for log to work properly')
  }
  
  if (isDev()) {
    console.group(msg);

    if (obj) console.log(obj);
    if (arr) {
      arr.forEach(a => {
        console.log(a);
      });
    }

    console.groupEnd();
  } else {
    let log = { msg };

    if (obj) log.obj = obj;
    if (arr) log.arr = arr;

    LogRocket.log(log)
  }
}

export const error = ({ msg, obj = null, arr = null }) => {
  if (isDev()) {
    console.group(msg);

    if (obj) console.error(obj);
    if (arr) {
      arr.forEach(a => {
        console.error(a);
      });
    }

    console.groupEnd();
  } else {
    let error = { msg };
    
    if (obj) error.obj = obj;
    if (arr) log.arr = arr;

    LogRocket.error(error)
  }
}